import React from 'react';
import { useTranslation } from 'react-i18next';

const WelcomeModal = () => {
    const { t } = useTranslation();
    return (
        <>
            <div className="modal fade" id="welcomWalletModal" tabIndex="-1" aria-labelledby="welcomWalletModalLabel" aria-hidden="true">
                <div className="modal-dialog modal-dialog-centered">
                    <div className="modal-content">
                        <div className="modal-header">
                            <h6 className="modal-title" id="welcomWalletModalLabel">{t('Notification')}</h6>
                            <button type="button" className="btn-close" data-bs-dismiss="modal" aria-label="Close"></button>
                        </div>
                        <div className="modal-body p-lg-4 text-center">
                            <p> Kccpad was merged to polypad  </p>
                            <p>1. Goto polypad site</p>
                            <p>2. Stay on site to claim tokens from existing IDOs</p>
                            <div className="mt-4">
                                <a href="https://app.polypad.com/" className="btn btn-primary">{t('Go to Polypad')}</a>
                                <a href="#" className="btn btn-outline-primary ms-3" data-bs-dismiss="modal">{t('Stay on KCS Pad')}</a>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </>
    );
}

export default WelcomeModal;


